import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-cancel-job-success-content',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './cancel-job-success-content.component.html',
  styleUrl: './cancel-job-success-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelJobSuccessContentComponent {}
